import { Chip, Tooltip } from "@material-ui/core";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import React from "react";
import { safeDateFormat } from "../utils";

// Marks a case that was closed and has since been reopened. Pass `reopenDate`
// and/or `reopenReason` to show them on hover.
export default function ReopenedChip({ reopenDate, reopenReason, style }) {
  const chip = (
    <Chip
      label="Reopened"
      size="small"
      style={{
        backgroundColor: "#F4EFF6",
        color: TEXT.brand,
        fontWeight: 600,
        borderRadius: "4px",
        ...style,
      }}
    />
  );

  if (!reopenDate && !reopenReason) return chip;
  const title = [
    reopenDate && `Reopened on ${safeDateFormat(reopenDate)}`,
    reopenReason && `Reason: ${reopenReason}`,
  ]
    .filter(Boolean)
    .join(" — ");
  return (
    <Tooltip title={title}>
      {chip}
    </Tooltip>
  );
}
